import { request } from "../_helpers/Auth";

const namespace = "/api/storage";

// Liste des fichiers
export const listFiles = () => {
    return request({
        url: namespace + "/",
        method: "get",
    });
};

// Upload d'un fichier
export const uploadFile = (formData) => {
    return request({
        url: namespace + "/",
        method: "post",
        data: formData, // formData doit contenir le fichier dans 'file'
        headers: { "Content-Type": "multipart/form-data" },
    });
};

// Générer URL temporaire d’un fichier
export const getFileUrl = (filename) => {
    return request({
        url: `${namespace}/${filename}`,
        method: "get",
    });
};

// Suppression d’un fichier
export const deleteFile = (filename) => {
    return request({
        url: `${namespace}/${filename}`,
        method: "delete",
    });
};
